import React, { useState, useEffect } from 'react';
import './Header.css';
import Countdown from 'react-countdown';
import { Link } from 'gatsby';
import { countdownPromoText } from '../../utils';

const Timer = ({ days, hours, minutes, seconds }) => {
    const numberFormatter = new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });
    days = numberFormatter.format(days);
    hours = numberFormatter.format(hours);
    minutes = numberFormatter.format(minutes);
    seconds = numberFormatter.format(seconds);

    return (
        <div className="row justify-content-center gx-4 gx-md-5 black-friday-timer">
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`P${days}D`}>
                    {days}
                </time>
                <span className="d-block timer-label">Days</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${hours}H`}>
                    {hours}
                </time>
                <span className="d-block timer-label">Hrs</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${minutes}M`}>
                    {minutes}
                </time>
                <span className="d-block timer-label">Min</span>
            </div>
            <span className="col-auto pt-1 px-0 fw-semibold">:</span>
            <div className="col-auto time-container px-1">
                <time className="d-block timer-number fw-semibold" dateTime={`PT${seconds}S`}>
                    {seconds}
                </time>
                <span className="d-block timer-label">Sec</span>
            </div>
        </div>
    );
};

function CountdownBanner({ endDate }) {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <Link to="/specials/" aria-label="View special offers and promotions">
            <section
                id="black-friday-countdown"
                className="d-flex align-items-center justify-content-center flex-column text-center py-3"
            >
                <span className="countdown-text pb-2 text-sm">{countdownPromoText}</span>
                {isMounted ? (
                    <Countdown date={endDate} renderer={Timer} />
                ) : (
                    <div style={{ visibility: 'hidden' }}>
                        <Timer days="00" hours="00" minutes="00" seconds="00" />
                    </div>
                )}
            </section>
        </Link>
    );
}

export default CountdownBanner;
